import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './services/auth/guard/auth.guard';
import { ProofOfDeliveryCodeGuard } from './services/proof-of-delivery/guard/proof-of-delivery-code.guard';
import { CodeModalComponent } from './modules/proof-of-delivery/components/code-modal/code-modal.component';
import { PublicUploadComponent } from './modules/proof-of-delivery/components/public-upload/public-upload.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    data: {
      allowedModes: ['provider', 'customer']
    },
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: 'listings-and-bookings',
    canActivate: [authGuard],
    data: {
      allowedModes: ['customer']
    },
    loadChildren: () =>
      import('./modules/shipments/shipments.module').then(
        (m) => m.ShipmentsModule
      ),
  },
  {
    path: 'broker-manager/simple-loads',
    canActivate: [authGuard],
    data: {
      allowedModes: ['customer']
    },
    loadChildren: () =>
      import('./modules/broker-payments/broker-payments.module').then((x) => x.BrokerPaymentsModule)
  },
  {
    path: 'broker-manager/advanced-loads',
    canActivate: [authGuard],
    data: {
      allowedModes: ['customer']
    },
    loadChildren: () =>
      import('./modules/projects/projects.module').then(
        (m) => m.ProjectsModule
      ),
  },
  {
    path: 'broker-manager/invoices-payments',
    canActivate: [authGuard],
    data: {
      allowedModes: ['customer']
    },
    loadChildren: () =>
      import('./modules/invoices-matching/invoices-matching.module').then((x) => x.InvoicesMatchingModule)
  },
  {
    path: 'broker-manager/customers',
    canActivate: [authGuard],
    data: {
      allowedModes: ['customer']
    },
    loadChildren: () =>
      import('./modules/create-customer/create-customer.module').then((x) => x.CreateCustomerModule)
  },
  {
    path: 'instant-quote',
    canActivate: [authGuard],
    data: {
      allowedModes: ['customer']
    },
    loadChildren: () =>
      import('./modules/instant-quote/instant-quote.module').then(
        (m) => m.InstantQuoteModule
      ),
  },
  {
    path: 'instant-rate-manager',
    canActivate: [authGuard],
    data: {
      allowedModes: ['provider']
    },
    loadChildren: () =>
      import('./modules/rate-manager/rate-manager.module').then(
        (m) => m.RateManagerModule
      ),
  },
  {
    path: 'style-guide',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/style-guide/style-guide.module').then(
        (m) => m.StyleGuideModule
      ),
  },
  {
    path: 'view/proof-of-delivery/:customerId',
    canActivate: [ProofOfDeliveryCodeGuard],
    canMatch: [ProofOfDeliveryCodeGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/proof-of-delivery/proof-of-delivery.module').then(
            (m) => m.ProofOfDeliveryModule
          )
      },
      {
        path: 'code',
        component: CodeModalComponent,
        outlet: 'modal'
      }
    ],
  },
  {
    path: 'pod-upload/:token',
    component: PublicUploadComponent
  },
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./components/access-denied/access-denied.component').then((x) => x.AccessDeniedComponent)
  },
  {
    path: 'settings',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/settings.module').then((x) => x.SettingsModule)
  },
  {
    path: 'financials',
    canActivate: [authGuard],
    data: {
      allowedRoles: ['provider']
    },
    loadChildren: () =>
      import('./modules/financials/financials.module').then((x) => x.FinancialsModule)
  },

  // {
  //   path: 'financials/providers',
  //   canActivate: [authGuard],
  //   loadChildren: () =>
  //     import('./modules/financials/financials.module').then((x) => x.FinancialsModule)
  // },

  {
    path: 'esg',
    canActivate: [authGuard],
    data: { allowedModes: ['provider'] },
    loadChildren: () =>
      import('./modules/esg/esg.module').then((m) => m.EsgModule),
  },
  {
    path: 'multi-listing',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/multi-listing/multi-listing.module').then((x) => x.MultiListingModule)
  },
  {
    path: 'invoices-matching',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/invoices-matching/invoices-matching.module').then((x) => x.InvoicesMatchingModule)
  },
  {
    path: 'invoices-matching/create-customer',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/create-customer/create-customer.module').then((x) => x.CreateCustomerModule)
  },
  {
    path: 'integrations',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/integrations/integrations.module').then(m => m.IntegrationsModule)
  },
  {
    path: 'payments/quotes',
    canActivate: [authGuard],
    data: {
      allowedModes: ['customer']
    },
    loadChildren: () =>
      import('./modules/payments-quotes/payments-quotes.module').then(m => m.PaymentsQuotesModule)
  },
  {
    path: 'allocator-view',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/allocator-view/allocator-view.module').then(m => m.AllocatorViewModule)
  },
  {
    path: 'my-jobs',
    canActivate: [authGuard],
    data: {
      allowedModes: ['provider']
    },
    loadChildren: () =>
      import('./modules/my-jobs/my-jobs.module').then(
        (m) => m.MyJobsModule
      ),
  },
  // { path: 'view/proof-of-delivery/:customer_id',
  //   canActivate:[ProofOfDeliveryCodeGuard],
  //   canMatch:[ProofOfDeliveryCodeGuard],
  //   loadChildren: () => import('./modules/proof-of-delivery/proof-of-delivery.module').then(m => m.ProofOfDeliveryModule)
  // },
  {
    path: '**',
    loadComponent: () =>
      import('./components/cms/cms.component').then((x) => x.CmsComponent)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
